module.exports = __webpack_public_path__ + "static/media/vrouw-die-palliatieve-zorg-krijgt-schildert-in-haar-zolder-atelier-large.416a1393.jpg";